import dispatchingPlan from '../DispatchingPlan';
import  dispatchTactics from '../DispatchTactics';
/**
 *基础数据路由
 */
const Dispatch = [
    {
        name: '调度计划管理',
        path: '/dispatch/dispatchingPlan',
        component: dispatchingPlan
    },
    {
        name: '调度计划告警策略',
        path: '/dispatch/dispatchTactics',
        component: dispatchTactics
    },
];
export default Dispatch
